module.exports = __webpack_public_path__ + "static/media/pajoohyar-app.fa17a3c5.png";